import { AxiosResponse } from "axios";
import BaseAPI from "../api";
import { pagination_list } from "../type";

const path: string = "notification/config";

export interface notification_config_list extends pagination_list {
    search?: string;
}
export type notification_config_data = {
    notification_config_name: string;
    via_web: boolean;
    via_email: boolean;
    send_now: boolean;
    send_at_event_date: boolean;
    send_before_event_date: number | string;
    send_after_event_date: number | string;
    id_notification_config?: number
}

export class NotificationsConfigApi extends BaseAPI {

    static list(params: notification_config_list): Promise<AxiosResponse> {
        return this.api.get(`${path}`, { params })
    }
    static update_logs(id_notification_config: number, body: notification_config_data): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_notification_config}`, body)
    }
}